import { Heart } from 'lucide-react';
import { toast } from 'sonner';
import { useLang } from '../i18n';
import { useFavorites } from '../utils/favorites';

export const FavoriteButton = ({ experience, className = '' }) => {
  const { t } = useLang();
  const { isFavorite, toggle } = useFavorites();
  const saved = isFavorite(experience?.id);
  const label = saved ? t('favorites.remove') : t('favorites.save');
  return (
    <button
      type="button"
      aria-label={label}
      aria-pressed={saved}
      title={label}
      data-testid={`favorite-${experience?.slug}`}
      onClick={async (event) => {
        event.preventDefault(); event.stopPropagation();
        try { await toggle(experience); }
        catch (error) { toast.error(t('favorites.error'), { description: String(error.message) }); }
      }}
      className={`grid h-11 w-11 place-items-center rounded-full border border-white/60 bg-white/95 text-eco-green shadow-sm transition-colors hover:bg-eco-cream focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-eco-gold ${className}`}
    >
      <Heart size={19} fill={saved ? 'currentColor' : 'none'} />
    </button>
  );
};
